import {useItemDataState} from 'providers';
import React, {useEffect} from 'react';
import {useNavigate, useParams} from 'react-router';
import {BoardItemDrawer} from './drawers';
import {appRoutes} from 'routes';
import {useBoardRedux, useGetItemDataById} from 'hooks';

export const ItemDataIndex: React.FC = () => {
    const {ticketNo, tenantId, workspaceId, boardId} = useParams();
    const useItemStateHanlder = useItemDataState();
    const navigate = useNavigate();
    const {getItemDataById, getItemDataByIdLoading, getItemDataByIdResponse} = useGetItemDataById();

    const {selectedBoard, allBoards} = useBoardRedux();

    useEffect(() => {
        if (ticketNo && selectedBoard?.id && !isNaN(Number(ticketNo))) {
            if (boardId !== selectedBoard.slug) {
                const paramsSlugBoardId = allBoards.find(x => x.slug === boardId)?.id;
                if (paramsSlugBoardId) getItemDataById(Number(ticketNo), paramsSlugBoardId);
            } else {
                getItemDataById(Number(ticketNo), selectedBoard?.id);
            }
        }
    }, [ticketNo, selectedBoard]);

    const handleDrawerClose = () => {
        navigate(appRoutes.workspace.boardListing(tenantId, workspaceId, boardId));
    };
    return (
        <>
            {ticketNo && getItemDataByIdResponse && (
                <BoardItemDrawer
                    boardId={selectedBoard?.slug || ''}
                    getItemDataById={() => {
                        if (selectedBoard) {
                            getItemDataById(Number(ticketNo), selectedBoard?.id);
                        }
                    }}
                    getItemDataByIdLoading={getItemDataByIdLoading}
                    getItemDataByIdResponse={getItemDataByIdResponse}
                    open={!!ticketNo}
                    handleUpdateItemDataState={useItemStateHanlder.updateItemDataFieldsInState}
                    handleDrawerClose={handleDrawerClose}
                    removeItemDataFromState={useItemStateHanlder.removeBoardItemsData}
                />
            )}
        </>
    );
};

export default ItemDataIndex;
